import {FavCustomizeView} from "module/selpan/menu/FavCustomizeView";
import template_FavCustomManualOrderView from './FavCustomManualOrderView.ejs';

/**
 * only controls SelPanView.status modes
 */
export const FavCustomManualOrderView = FavCustomizeView.extend({
	render: function () {
		let index = this.fav.custom.get('index');
		index = index && index.get('value');
		index = index && index.length;
		this.$el.html(template_FavCustomManualOrderView({
			hasData: {
				index: index
			}
		}));
	}
});